import { render, staticRenderFns } from "./PageEditor.vue?vue&type=template&id=3b646168&scoped=true&"
import script from "./PageEditor.vue?vue&type=script&lang=js&"
export * from "./PageEditor.vue?vue&type=script&lang=js&"
import style0 from "./PageEditor.vue?vue&type=style&index=0&id=3b646168&prod&lang=scss&scoped=true&"
import style1 from "./PageEditor.vue?vue&type=style&index=1&id=3b646168&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b646168",
  null
  
)

export default component.exports